/* eslint-disable @typescript-eslint/no-explicit-any */
import useApiMutation from "@/common/hooks/use-api-mutation";
import useApiQuery from "@/common/hooks/use-api-query";
import { ApiQueryOptions } from "@/api-services/types/api.types";
import { fetchApi } from "@/api-services/config/fetch-api";
import { ApiRequestMethod } from "@/api-services/config/api-handler";

type FetcherArgs = {
  url: string;
  method: ApiRequestMethod;
};

const createFetcher =
  <R, T>(
    { url, method }: FetcherArgs,
    options?: { deleteWithBody?: boolean },
  ) =>
  (data: any, headers: any) => {
    const finalUrl = typeof data === "string" ? `${url}/${data}` : url;

    return fetchApi<R, T>(
      finalUrl,
      typeof data === "string" ? undefined : data,
      headers,
      method,
      false,
      options,
    );
  };
/**
 * Generic mutation hook
 */
export const useApiMutationHook = <R, T>(
  queryKey: string,
  url: string,
  method: "GET" | "POST" | "DELETE" | "PUT" | "PATCH" = "GET",
  serviceType: string,
  options?: {
    deleteWithBody?: boolean;
  },
) => {
  const fetcher = createFetcher<R, T>(
    {
      url,
      method: method as any,
    },
    options,
  );

  return useApiMutation<any, T>([queryKey], fetcher, serviceType);
};

/**
 * Generic query hook
 */
export const useApiQueryHook = <R, T>(
  queryKey: string,
  url: string,
  serviceType: string,
  data?: any,
  options?: ApiQueryOptions<T>,
  method: "GET" | "POST" = "GET",
) => {
  const fetcher = createFetcher<R, T>({
    url,
    method: method as any,
  });

  return useApiQuery<R, T>([queryKey], fetcher, serviceType, data, options);
};
